<script lang="ts">
	//Ui
	import { PhotoIcon } from "@hitit/new_ui";
	import DragAndDrop from "@hitit/hub/src/components/DragAndDrop.svelte";
	import AreYouSure from "../common/AreYouSure.svelte";
	import ComponentLoading from "../common/ComponentLoading.svelte";
	//Utils
	import { popup } from "../../store";
	import { t, api, profileImage } from "../../../stores";
	import { OBJECT_PURPOSE_PROFILE_IMAGE } from "@hitit/api";
	import { onDestroy } from "svelte";
	import axios from "axios";

	//Image
	import profileImageFallback from "../../../assets/profile.png?raw-base64";

	export let userId = "";

	let mouseenter = false;
	let loading = false;

	async function updateImage(e: { detail: File }) {
		try {
			loading = true;
			const file = e.detail;
			const extMatch = file.name.match(/\.([^\.]+)$/);
			if (!extMatch) throw new Error("format not match");
			const r = await $api.getFileUploadUrl({
				fileName: file.name.replace(/\.([^\.]+)$/, ".png"),
				fileType: "PNG",
				objectPurpose: OBJECT_PURPOSE_PROFILE_IMAGE,
			});

			await axios.put(r.data.url, file);
			await profileImage.refreshProfileImage($api, userId, file);
		} catch (e) {
			alert($t("sso.error.unknownError"));
		} finally {
			loading = false;
		}
	}
	function deleteHandler() {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: "hub.profile.are_you_sure_you_want_delete_profile_img",
				accept: () => {
					setDefaultImage();
					$popup = undefined;
				},
				cancel: () => ($popup = undefined),
			},
		};
	}

	function setDefaultImage() {
		let arr = profileImageFallback.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		const file = new File([u8arr], "defaultImage.png", { type: mime });
		updateImage({ detail: file });
	}

	onDestroy(() => {
		$popup = undefined;
	});
</script>

<div class="profile-image-box">
	<img id="profile-image" src={$profileImage} alt="profile" />
	<div
		id="image-cover"
		class:loading={loading}
		class:enter={mouseenter}
		on:dragover={() => {
			mouseenter = true;
		}}
		on:dragleave={() => {
			mouseenter = false;
		}}
		on:mouseleave={() => {
			mouseenter = false;
		}}
		on:mouseenter={() => {
			mouseenter = true;
		}}
	>
		{#if loading}
			<ComponentLoading />
		{:else}
			<DragAndDrop on:file-update={updateImage} let:enter>
				<div class="drop-inner">
					<div class="photoicon">
						<PhotoIcon active={mouseenter || enter} />
					</div>
					<div class="description">
						<span>{$t("hub.store.ko_registration.Click")}</span>
						<span class="or">{$t("hub.store.ko_registration.or")}</span>
						<span>{$t("hub.store.ko_registration.Drop")}</span>
					</div>
				</div>
			</DragAndDrop>
		{/if}
	</div>
	<img
		class="delete-icon"
		src="/Icons/deleteIcon.png"
		alt={"delete"}
		on:click={deleteHandler}
	/>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.profile-image-box {
		width: 250px;
		height: 250px;
		position: relative;

		&:hover {
			cursor: pointer;
		}

		#profile-image {
			box-sizing: border-box;
			width: 250px;
			height: 250px;
			border-radius: 999px;
			border: solid 2px #6b93f3;
			object-fit: cover;
		}

		#image-cover {
			position: absolute;
			width: 246px;
			height: 246px;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			background-color: rgba($color: #46474b, $alpha: 0.6);
			border-radius: 999px;

			.drop-inner {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				.photoicon {
					width: 50px;
					height: 50.2px;
				}

				.description {
					display: none;
				}
			}
		}
		.delete-icon {
			position: absolute;
			right: -30px;
			bottom: 0;
			width: 30px;
			height: 30.2px;
			object-fit: contain;
		}
	}

	@include DesktopSize {
		.profile-image-box {
			width: 350px;
			height: 350px;

			#profile-image {
				box-sizing: border-box;
				width: 350px;
				height: 350px;
				border-radius: 999px;
				box-sizing: border-box;
				border: solid 4px #6b93f3;
			}

			#image-cover {
				width: 346px;
				height: 346px;
				opacity: 0;
				transition: opacity 0.5s;
				&.loading {
					opacity: 1;
				}
				&.enter {
					opacity: 1;
				}

				.drop-inner {
					gap: 23px;
					.description {
						display: flex;
						align-items: baseline;
						gap: 20px;

						font-weight: 500;
						font-size: 1.25rem;
						color: white;
						.or {
							color: #bcbfc3;
							font-size: 1rem;
							font-weight: 300;
						}
					}
				}
			}
			.delete-icon {
				right: 0px;
				width: 36px;
				height: 28.6px;
				object-fit: contain;
			}
		}
	}
</style>
